module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<legend>'+
((__t=( i18n.tc("ControlGeneralAlarm", "General alarm input") ))==null?'':__t)+
'</legend><div data-region="general-alarm-input-switch"></div><div data-region="follow-main-alarm-switch"></div><hr><div data-region="gpai-message"></div><hr><fieldset class="button-wrap"><button data-click="gpai-close">'+
((__t=( i18n.tc("ChangePassword", "Close") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
